import { downloadFile } from "../../lib/download";
import { incidentFilterQuery, type IncidentFilters } from "../incidents/api";

/**
 * Export feature (F-012/NF-012, US-011): thin wrappers over the shared
 * authenticated download helper. The server names the file via
 * Content-Disposition (vorfaelle_{date}.csv / vorfall_{nummer}_{date}.pdf);
 * the fallbacks below only cover an unparseable header.
 */

/**
 * GET /exports/incidents.csv - the CURRENT list filters ride along as query
 * params (exactly the list query's serialization, minus cursor/limit).
 */
export function downloadIncidentsCsv(filters: IncidentFilters): Promise<void> {
  return downloadFile(
    `/exports/incidents.csv${incidentFilterQuery(filters)}`,
    "vorfaelle.csv",
  );
}

/** GET /exports/incidents/{id}.pdf - one incident as PDF (AC-013). */
export function downloadIncidentPdf(
  id: string,
  fallbackName: string,
): Promise<void> {
  return downloadFile(`/exports/incidents/${id}.pdf`, fallbackName);
}
